import ko from 'knockout';
import _ from 'lodash';
import Vue from 'vue';
import vuetify from '../../../../plugins/vuetify';
import MenuIcons from '../../../../app/helpers/menu-icons';
import ForgotPassword from '../../components/forgotPassword/forgotPassword.vue';
import templateMarkup from 'raw-loader!./forgot-password.html';

class ForgotPasswordView {
    constructor(params) {
        let self = this;

        this.vueForgotPassword = new Vue({
            el: '#vueForgotPassword',
            vuetify,
            components: {
                'forgot-password': ForgotPassword
            }
        });
    }

    dispose() {
        if (this.vueForgotPassword) {
            this.vueForgotPassword.$destroy();
            this.vueForgotPassword.$el.parentNode.removeChild(this.vueForgotPassword.$el);
        }
    }
}

ko.components.register('forgot-password-view', { template: templateMarkup, viewModel: ForgotPasswordView });

export default { template: templateMarkup, viewModel: ForgotPasswordView }
